import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Tether from 'tether';
import { Provider } from 'react-redux';

class TetherComponent extends React.Component {
    static contextTypes = {
        store: PropTypes.shape({
            subscribe: PropTypes.func.isRequired,
            dispatch: PropTypes.func.isRequired,
            getState: PropTypes.func.isRequired,
        }),
    };

    static propTypes = {
        children: PropTypes.element.isRequired,
        target: PropTypes.string.isRequired,
    };

    // Called after the first render().
    componentDidMount() {
        this.renderRemote(this.context.store);
        // this._tether = { position: function() {} };
        if (!this._tether) {
            this._tether = new Tether({
                element: this.getContainer(),
                target: this.props.target,
                attachment: 'top center',
                optimizations: {
                    gpu: false,
                    allowPositionFixed: false,
                },
                classPrefix: 'cl-popover',
                classes: {
                    element: 'cl-popover',
                },

                constraints: [
                    {
                        to: 'window',
                        attachment: 'together',
                        pin: ['left', 'right'],
                    },
                ],
            });
        }
        this._tether.position();
    }

    // Called after all other render()s.
    componentDidUpdate() {
        this.renderRemote();
        this._tether.position();
    }

    componentWillUnmount() {
        if (this._tether) {
            this._tether.destroy();
            delete this._tether;
        }

        const DOMNode = this.getContainer();
        ReactDOM.unmountComponentAtNode(DOMNode);
        DOMNode.parentNode.removeChild(DOMNode);
        // Don't hold a reference to this DOM node. If it's getting unmounted
        // it may not matter, but I'm not sure.
        delete this.container;
    }

    getContainer = () => {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.id = 'popover-container';
            this.getParent().appendChild(this.container);
        }
        return this.container;
    };

    getParent = () => {
        // I tried moving this so that the elements could live closer to the
        // target, but thether just keeps moving the back to the body.
        return document.body;
    };

    renderRemote = () => {
        ReactDOM.render(
            <Provider store={this.context.store}>
                {this.props.children}
            </Provider>,
            this.getContainer()
        );
    };

    render() {
        // This is a non-visual element. It's able to mount even though
        // the render method doesn't do anything.
        return false;
    }
}

export default TetherComponent;



// WEBPACK FOOTER //
// ./src/components/tether.jsx